<template>
  <div>
    <!-- 契約modal -->
    <b-modal
    id="business-add-edit-modal"
    ref="business-add-edit-modal"
    :title="isNew ? '新增業務' : `修改業務-${data.number}`"
    size="xl"
    centered
    hide-footer
    header-class="head-modal"
    :no-close-on-backdrop="true"
    v-model="modalShow"
  >
    <b-card
      border-variant="secondary"
      header="業務人員"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-radio-group
        v-if="isNew"
        v-model="data.type"
        :options="options.type"
        class="mb-2"
      ></b-form-radio-group>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名" class="star">
            <b-form-input v-model="data.name" @change="changeSaleName()"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="首件回饋組別" :class="['mb-0']">
            <b-form-radio-group
              class="d-flex align-items-center h-100"
              v-model="data.first_return_plan"
              :options="options.firstReturnPlan"
            ></b-form-radio-group>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號" class="star">
            <b-form-input
              v-model="data.ID_number"
              @change="changeIDNumber()"
              :state="IDNumberVerifyStatus"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="出生日期" :class="['mb-0', {'star': isNew}]">
            <date-picker
              v-model="data.birthday"
              :position="'left'"
              :manualInput="true"
              placeholder="手動輸入時，日期範例：065-02-26"
            ></date-picker>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="行動電話" class="star">
            <b-form-input type="text" v-model="data.cellphone"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="市話">
            <b-form-input type="text" v-model="data.phone"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="傳真" >
            <b-form-input type="text" v-model="data.fax"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="保險證照">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.license"></b-form-checkbox>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="通訊郵遞區號">
        <b-form-input v-model="data.postalCode"></b-form-input>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="通訊地址" class="star">
        <b-form-input v-model="data.address" @change="changeAddress('postalCode', data.address)"></b-form-input>
      </b-form-group>
    </b-card>

    <b-card
      border-variant="secondary"
      header="緊急連絡人"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名">
            <b-form-input v-model="data.emergency_name"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="關係">
            <b-form-input v-model="data.emergency_relation"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="電話">
        <b-form-input v-model="data.emergency_phone"></b-form-input>
      </b-form-group>
    </b-card>

    <b-card
      border-variant="secondary"
      header="推薦人"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="d-flex align-items-center">
        <b-form-group label-cols="auto" label-cols-lg="auto" label="業務員編號" class="mb-0 star">
          <b-form-input v-model="data.upper_number" readonly></b-form-input>
        </b-form-group>

        <b-form-input v-model="data.upper_name" class="w-25" readonly></b-form-input>

        <b-button
          class="ml-2"
          variant="primary"
          size="sm"
          @click="openBusinessModal"
        >
          搜尋業務員
        </b-button>
      </div>
    </b-card>

    <b-card
      border-variant="secondary"
      header="帶件報酬會員"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <div class="d-flex align-items-center">
            <b-form-group label-cols="auto" label-cols-lg="auto" label="契約編號">
              <b-form-input type="text" v-model="data.return_member_number" readonly></b-form-input>
            </b-form-group>

            <b-button
              class="ml-2 mb-2"
              variant="primary"
              size="sm"
              @click="openContractModal"
            >
              搜尋契約
            </b-button>

            <b-button
              class="ml-2 mb-2"
              variant="danger"
              size="sm"
              @click="clearContract"
            >
              清除
            </b-button>
          </div>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="姓名">
            <b-form-input type="text" v-model="data.return_member_name" readonly></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="身分證字號">
            <b-form-input type="text" v-model="data.return_member_ID_number" readonly></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="加入日期" :class="['mb-0']">
            <date-picker
              v-model="data.return_member_join_date"
              :position="'left'"
              :disabled="true"
            ></date-picker>
          </b-form-group>
        </div>
      </div>
    </b-card>

    <b-card
      border-variant="secondary"
      header="銀行"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行代碼">
            <b-form-input type="text" v-model="data.bankCode" @change="changeBankCode"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行名稱">
            <b-form-input type="text" v-model="data.bank"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="分行代碼">
            <b-form-input type="text" v-model="data.branchCode" :disabled="!status.checkBranchCode" @change="changeBranchCode"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="分行名稱">
            <b-form-input type="text" v-model="data.branch" :disabled="!status.checkBranchCode"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行戶名">
            <b-form-input type="text" v-model="data.bank_name"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="銀行帳號">
            <b-form-input type="text" v-model="data.bank_account"></b-form-input>
          </b-form-group>
        </div>
      </div>

<!-- :class="[{'star': !isNew && (data.name !== data.bank_name)}]" -->
      <b-form-group label-cols="auto" label-cols-lg="auto" label="戶名身分證字號">
        <b-form-input type="text" v-model="data.bank_ID_number"></b-form-input>
      </b-form-group>
    </b-card>

    <b-card
      border-variant="warning"
      header="其他"
      header-border-variant="warning"
      header-bg-variant="warning"
      header-text-variant="white"
      align="left"
      class="mb-4"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="任命日期" class="star">
        <date-picker
          v-model="data.join_date"
          :position="'left'"
        ></date-picker>
      </b-form-group>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="備註">
         <b-form-textarea
          v-model="data.remark"
          rows="3"
        />
      </b-form-group>
    </b-card>

    <b-card
      border-variant="secondary"
      header="報聘"
      header-border-variant="secondary"
      header-bg-variant="secondary"
      header-text-variant="white"
      align="left"
    >
      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="是否繳費">
            <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model.number="data.join_check"></b-form-checkbox>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="金額">
            <b-form-input v-model="data.join_amount"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="繳款來源">
            <b-form-select
              v-model="data.join_payment_source"
              :options="options.joinPaymentSource"
            >
              <template #first>
                <b-form-select-option :value="null" disabled>-- 請選擇 --</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="繳款時間">
            <date-picker
              v-model="data.join_payment_at"
              :position="'left'"
            ></date-picker>
          </b-form-group>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="發票">
            <b-form-input v-model="data.join_invoice"></b-form-input>
          </b-form-group>
        </div>

        <div class="col-6">
          <b-form-group label-cols="auto" label-cols-lg="auto" label="匯款戶名">
            <b-form-input v-model="data.join_bank_name"></b-form-input>
          </b-form-group>
        </div>
      </div>

      <b-form-group label-cols="auto" label-cols-lg="auto" label="備註">
        <b-form-textarea
          v-model="data.join_remark"
          rows="3"
        />
      </b-form-group>
    </b-card>

    <div class="text-center mt-4">
      <b-button
        class="mr-2"
        variant="success"
        size="sm"
        @click="sumit()"
      >
        確定
      </b-button>
      <b-button
        variant="danger"
        size="sm"
        class="mr-4"
        @click="$bvModal.hide('business-add-edit-modal')"
      >
        取消
      </b-button>
    </div>
  </b-modal>

  <!-- 業務modal -->
  <b-modal
    id="search-business-modal"
    ref="search-business-modal"
    title="業務"
    size="lg"
    centered
    hide-footer
    header-class="head-modal"
  >
    <div class="row">
      <div class="col-3 mb-4">
        <b-form-select
          v-model="searchBusiness.status"
          :options="options.status" />
      </div>

      <div class="col-3 mb-4">
        <b-form-input
          autofocus
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務編號"
          v-model="searchBusiness.number"
          @keyup.enter="getSales(1)" />
      </div>

      <div class="col-3">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="業務姓名"
          v-model="searchBusiness.name"
          @keyup.enter="getSales(1)" />
      </div>

      <div class="col-3">
        <b-button variant="success" @click="getSales(1)">搜尋</b-button>
      </div>
    </div>

    <tables-page
      :tableData="business.table_data"
      :tableFields="business.table_fields"
      :pageData="business.page"
      v-on:result="getSales"
    >
      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          @click="selectSalesPerson(row.item)"
        >
          選取
        </b-button>
      </template>
    </tables-page>
  </b-modal>

  <!-- 契約modal -->
  <b-modal
    id="search-contract-modal"
    ref="search-contract-modal"
    title="契約"
    size="lg"
    centered
    hide-footer
    header-class="head-modal"
  >
    <div class="row">
      <div class="col-5 mb-4">
        <b-form-input
          autofocus
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="契約編號"
          v-model="searchContract.number"
          @keyup.enter="getContract(1)" />
      </div>

      <div class="col-5">
        <b-form-input
          class="mb-2 mr-sm-2 mb-sm-0"
          placeholder="互助姓名"
          v-model="searchContract.member_name"
          @keyup.enter="getContract(1)" />
      </div>

      <div class="col-2">
        <b-button variant="success" @click="getContract(1)">搜尋</b-button>
      </div>
    </div>

    <tables-page
      :tableData="contract.table_data"
      :tableFields="contract.table_fields"
      :pageData="contract.page"
      v-on:result="getContract"
    >
      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date) }}
      </template>

      <template #cell(function)="row">
        <b-button
          variant="info"
          size="sm"
          @click="selectContractPerson(row.item)"
        >
          選取
        </b-button>
      </template>
    </tables-page>
  </b-modal>
</div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import businessApi from "@/models/API/businessApi";
import contractApi from "@/models/API/contractApi";
import datePicker from '@/components/common/DatePicker';
import { convertRocDate, validateTWID, verifyOldResidencePermit, getRocZipcode } from "@/models/HELPERS/common.js";
import { BankCodes, BranchCodes } from "@/models/HELPERS/utilitiesData.js";

export default {
  name: 'BusinessAddEditModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    },
    isNew: {
      type: Boolean,
      required: false,
      default: true
    },
  },
  components: {
    TablesPage,
    datePicker
  },
  data () {
    return {
      IDNumberVerifyStatus: null,
      IDNumberVerifySaveStatus: true,
      originalIDNumber: '',
      options: {
        type: [
          { value: 0, text: '保險' },
          { value: 1, text: 'Q' },
          { value: 2, text: '一般' }
        ],
        firstReturnPlan: [
          { value: 'A', text: 'A' },
          { value: 'B', text: 'B' },
        ],
        status: [
          { value: 0, text: '正常' },
          { value: 1, text: '失效' },
          { value: 2, text: '停權' },
        ],
        joinPaymentSource: [
          { value: '台中', text: '台中' },
          { value: '現金', text: '現金' },
        ],
      },
      status: {
        checkBranchCode: false
      },
      searchBusiness: {
        status: 0,
        number: '',
        name: '',
      },
      searchContract: {
        number: '',
        member_name: ''
      },
      business: {
        table_fields: [
          {
            key: "number",
            label: "業務編號",
          },
          {
            key: "name",
            label: "業務姓名",
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
      },
      contract: {
        table_fields: [
          {
            key: "number",
            label: "契約編號",
          },
          {
            key: "member_name",
            label: "互助人",
          },
          {
            key: "member_ID_number",
            label: "身分證"
          },
          {
            key: "join_date",
            label: "入會日期"
          },
          {
            key: "function",
            label: "功能"
          }
        ],
        table_data: [],
        page: {},
      },
    }
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.IDNumberVerifyStatus = null;
          this.originalIDNumber = this.data.ID_number || '';
          this.initCheckBankCodesStatus();
        }
      },
      immediate: false
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  },
  mounted() {
    this.businessApi = new businessApi();
    this.contractApi = new contractApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.business.page = Object.assign({}, this.businessApi.page);
      this.contract.page = Object.assign({}, this.contractApi.page);

      this.getSales();
      this.getContract();
    },
    convertRocDate,
    // 初始化，檢查分行代碼狀態(編輯時 不檢查)
    initCheckBankCodesStatus() {
      if (!this.isNew) this.status.checkBranchCode = true;
    },
    sumit() {
      try {
        const required =
          ['name',
          'ID_number',
          'cellphone',
          'address',
          'upper_id',
          'join_date'];

        if (this.isNew) {
          // required.push('first_return_plan');
          required.push('birthday');
        } else {
          // required.push('return_member_join_date');
        }

        // if (!this.isNew && (this.data.name !== this.data.bank_name)) required.push('bank_ID_number');

        const data = this.data;
        const status = required.every(item => {
          return Array.isArray(data[item]) ? data[item].length !== 0 : data[item] != null && data[item] !== '';
        });

        if (!status) {
          throw { message: '欄位請填寫完整', title: '業務' };
        } else if (!validateTWID(this.data.ID_number) && !verifyOldResidencePermit(this.data.ID_number)) {
          throw { message: '業務人員身分證字號，不符合格式', title: '業務' };
        } else if (this.data.return_member_ID_number && !validateTWID(this.data.return_member_ID_number) && !verifyOldResidencePermit(this.data.return_member_ID_number)) {
          throw { message: '帶件報酬會員身分證字號，不符合格式', title: '業務' };
        } else if (this.data.bank_ID_number && !validateTWID(this.data.bank_ID_number) && !verifyOldResidencePermit(this.data.bank_ID_number)) {
          throw { message: '戶名身分證字號，不符合格式', title: '業務' };
        } else if (!this.IDNumberVerifySaveStatus && (this.originalIDNumber !== this.data.ID_number)) {
          throw { message: '業務身分證之前有加入過', title: '業務' };
        }

        this.resetSearchCondition();

        this.$emit('sumit');
      } catch(message) {
        this.businessApi.toast(() => {}, message, false);
      }
    },
    // 重置搜尋條件
    resetSearchCondition() {
      this.searchBusiness = {
        status: 0,
        number: '',
        name: '',
      };
      this.searchContract = {
        number: '',
        member_name: ''
      };

      this.getSales();
      this.getContract();
    },
    // 查詢業務
    getSales(pageIndex = null) {
      const params = {
        ...this.searchBusiness,
        'PageSize': this.business.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.business.page.pageIndex,
      };
      this.businessApi.getSales((response) => {
        const res = response.data;

        this.business.page.totalCount = res.total; // 總筆數
        this.business.table_data = res.data;
      }, params)
    },
    // 帶入選擇業務
    selectSalesPerson(item) {
      this.$set(this.data, 'upper_id', item.id);
      this.$set(this.data, 'upper_number', item.number);
      this.$set(this.data, 'upper_name', item.name);

      this.$root.$emit('bv::hide::modal', 'search-business-modal')
    },
    // 查詢契約
    getContract(pageIndex = null) {
      const params = {
        ...this.searchContract,
        'PageSize': this.contract.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.contract.page.pageIndex,
      };
      this.contractApi.getMember((response) => {
        const res = response.data;

        this.contract.page.totalCount = res.total; // 總筆數
        this.contract.table_data = res.data;
      }, params)
    },
    // 帶入選擇契約
    selectContractPerson(item) {
      this.$set(this.data, 'return_member_id', item.id);
      this.$set(this.data, 'return_member_number', item.number);
      this.$set(this.data, 'return_member_name', item.member_name);
      this.$set(this.data, 'return_member_ID_number', item.member_ID_number);
      this.$set(this.data, 'return_member_join_date', item.join_date);

      this.$root.$emit('bv::hide::modal', 'search-contract-modal')
    },
    // 更改銀行代碼
    changeBankCode() {
      const bank_codes = BankCodes.find(item => item.code === this.data.bankCode);

      if (bank_codes) {
        this.$set(this.data, 'bank', bank_codes.name);
        this.status.checkBranchCode = true;
      } else {
        const result = { message: '銀行代碼錯誤', title: '業務' };
        this.contractApi.toast(() => {}, result, false);

        this.status.checkBranchCode = false;
        this.data.bank = '';
      }

      this.data.branchCode = '';
      this.data.branch = '';
      this.$forceUpdate();
    },
    // 更改分行代碼
    changeBranchCode() {
      const branch_codes = BranchCodes[this.data.bankCode].find(item => item.code === `${this.data.bankCode}${this.data.branchCode}`)

      if (branch_codes) {
        this.$set(this.data, 'branch', branch_codes.name);
      } else {
        const result = { message: '分行代碼錯誤', title: '業務' };
        this.contractApi.toast(() => {}, result, false);

        this.data.branch = '';
      }

      this.$forceUpdate();
    },
    // 開啟業務員modal
    openBusinessModal() {
      this.$root.$emit('bv::show::modal', 'search-business-modal');
    },
    // 開啟契約modal
    openContractModal() {
      this.$root.$emit('bv::show::modal', 'search-contract-modal')
    },
    clearContract() {
      this.$set(this.data, 'return_member_id', '');
      this.$set(this.data, 'return_member_number', '');
      this.$set(this.data, 'return_member_name', '');
      this.$set(this.data, 'return_member_ID_number', '');
      this.$set(this.data, 'return_member_join_date', '');
    },
    // 改變地址，自動帶入郵遞區號
    changeAddress(postalCode_key, address) {
      this.$set(this.data, postalCode_key, getRocZipcode(address));
    },
    // 改變業務姓名
    changeSaleName() {
      if (!this.data.bank_name) {
        this.$set(this.data, 'bank_name', this.data.name);
      }
    },
    // 改變業務身分證字號
    changeIDNumber() {
      if (!this.data.bank_ID_number) {
        this.$set(this.data, 'bank_ID_number', this.data.ID_number);
      }

      this.verifyIDNumber();
    },
    // 驗證業務人身分證是否之前有加入過
    verifyIDNumber() {
      if (!this.data.ID_number || this.data.ID_number.length !== 10 || this.originalIDNumber === this.data.ID_number) {
        this.IDNumberVerifyStatus = null;
        this.IDNumberVerifySaveStatus = true;
        return;
      }

      const params = {
        'ID_number': this.data.ID_number,
      };
      this.businessApi.getSales((response) => {
        const res = response.data;

        const allStatusOneOrEmpty = res.data.length === 0 || res.data.every(item => item.status === 1);
        this.IDNumberVerifyStatus = allStatusOneOrEmpty;
        this.IDNumberVerifySaveStatus = allStatusOneOrEmpty;
      }, params, false)
    },
  }
}
</script>

<style lang="scss" scoped>
.star {
  position: relative;
  &:before {
    content: "*";
    color: red;
    position: absolute;
    top: 50%;
    left: -10px;
    transform: translateY(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/BusinessAddEditModal.vue